import { render, staticRenderFns } from "./SmallNavigationSection.vue?vue&type=template&id=74807256"
import script from "./SmallNavigationSection.vue?vue&type=script&lang=js"
export * from "./SmallNavigationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports